/* Hiemal32 owner (QR) pages. Shared by every h32-ol-* section.
   Everything hooks onto data-h32-* attributes, so sections can be added, removed and reordered freely. */
(function () {
  if (window.H32Owner) { window.H32Owner.scan(); return; }
  var O = window.H32Owner = {};
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__h32' + key]) return false; el['__h32' + key] = true; return true; }
  function cfg() { var r = $('[data-h32-cfg]'); return { bonus: (r && r.getAttribute('data-bonus')) || '15', support: (r && r.getAttribute('data-support')) || 'support@hiemal32.com', product: (r && r.getAttribute('data-product')) || '' }; }

  /* ---------- countdowns ---------- */
  function monthEnd() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth() + 1, 1); }
  function seasonEnd(el) { var e = el.getAttribute('data-end'); if (!e) return null; var d = new Date(e + 'T00:00:00'); if (isNaN(d)) return null; d.setDate(d.getDate() + 1); return d; }
  function tick() {
    var now = Date.now();
    $$('[data-h32-clock]').forEach(function (c) {
      var target = c.getAttribute('data-h32-clock') === 'month' ? monthEnd() : seasonEnd(c);
      if (!target) return;
      var t = Math.max(0, target - now);
      var u = { d: Math.floor(t / 864e5), h: Math.floor(t / 36e5) % 24, m: Math.floor(t / 6e4) % 60, s: Math.floor(t / 1e3) % 60 };
      $$('[data-u]', c).forEach(function (b) { b.textContent = pad(u[b.getAttribute('data-u')]); });
    });
  }
  function paintDates() {
    var last = new Date(monthEnd() - 1);
    $$('[data-h32-month-end]').forEach(function (el) { el.textContent = 'ends ' + last.getDate() + ' ' + MONTHS[last.getMonth()]; });
    $$('[data-h32-month-short]').forEach(function (el) { el.textContent = 'ends ' + last.getDate() + ' ' + MONTHS[last.getMonth()]; });
    $$('[data-h32-countdown]').forEach(function (el) {
      var end = seasonEnd(el); if (!end) return;
      var days = Math.ceil((end - new Date()) / 864e5);
      el.textContent = days > 1 ? 'Season ends in ' + days + ' days' : days === 1 ? 'Season ends tomorrow' : 'New season starting soon';
    });
  }
  setInterval(tick, 1000);

  /* ---------- popups ---------- */
  var modals = {}, openHooks = {}, lastFocus = null;
  function registerModal(m) {
    if (!once(m, 'modal')) return;
    var name = m.getAttribute('data-h32-modal');
    if (modals[name] && modals[name] !== m && modals[name].parentNode) modals[name].parentNode.removeChild(modals[name]);
    modals[name] = m;
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(m); });
    $$('[data-h32-close]', m).forEach(function (x) { x.addEventListener('click', function () { closeModal(m); }); });
    $$('[data-copy]', m).forEach(function (b) {
      b.addEventListener('click', function () {
        var ok = function () { b.textContent = 'Copied ✓'; };
        if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy')).then(ok, ok); else ok();
      });
    });
    if (name === 'clubs') initClubsModal(m);
    if (name === 'join') initJoin(m);
  }
  function openModal(name, opener) {
    var m = modals[name]; if (!m) return false;
    Object.keys(modals).forEach(function (k) { if (k !== name && modals[k].classList.contains('is-open')) closeModal(modals[k], true); });
    lastFocus = opener || document.activeElement;
    m.hidden = false; m.classList.add('is-open'); document.documentElement.classList.add('h32ol-lock');
    var iframe = $('iframe[data-src]', m);
    if (iframe && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.getAttribute('data-src'));
    var x = $('[data-h32-close]', m); if (x) x.focus();
    if (openHooks[name]) openHooks[name]();
    return true;
  }
  function closeModal(m, keepLock) {
    m.classList.remove('is-open'); m.hidden = true;
    if (!keepLock) document.documentElement.classList.remove('h32ol-lock');
    var v = $('video', m); if (v) v.pause();
    var iframe = $('iframe[data-src]', m); if (iframe) iframe.removeAttribute('src');
    if (!keepLock && lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  function closeAll() { Object.keys(modals).forEach(function (k) { if (modals[k].classList.contains('is-open')) closeModal(modals[k]); }); }
  function scrollTo(id) { var el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return el; }
  function goUpload() {
    closeAll();
    var el = scrollTo('h32ol-upload');
    if (el) setTimeout(function () { var f = $('input[type=file]', el); if (f) f.focus({ preventScroll: true }); }, 450);
  }
  O.open = openModal;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-h32-open]');
    if (o) {
      var name = o.getAttribute('data-h32-open');
      if (name === 'upload') { e.preventDefault(); goUpload(); return; }
      if (name === 'faqs' || name === 'prizes' || name === 'help' || name === 'crew' || name === 'photos') { e.preventDefault(); closeAll(); scrollTo('h32ol-' + name); return; }
      if (modals[name]) { e.preventDefault(); openModal(name, o); }
      return;
    }
    var j = t.closest('[data-h32-join]');
    if (j) { e.preventDefault(); openJoin(j.getAttribute('data-h32-join'), j); return; }
    var a = t.closest('a[href^="#h32ol-"]');
    if (a) { var id = a.getAttribute('href').slice(1); if (document.getElementById(id)) { e.preventDefault(); closeAll(); if (id === 'h32ol-upload') goUpload(); else scrollTo(id); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Uploads go straight to Cloudinary (unsigned preset), with the form details saved on the file as context.
     Each file lands in h32/shots tagged h32-shot + h32-pending: that tag is the approval queue HQ reads.
     Any other endpoint gets the original multipart POST. */
  function isCloud(ep) { return /api\.cloudinary\.com/.test(ep || ''); }
  function ctxVal(v) { return String(v == null ? '' : v).replace(/[|=]/g, function (m) { return '\\' + m; }).slice(0, 900); }
  function userErr(msg) { var e = new Error(msg); e.userMsg = msg; return e; }
  function shrink(file) {
    /* phone photos over ~8MB are scaled to 3000px JPEG so they fit Cloudinary's 10MB image cap */
    return new Promise(function (res) {
      if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size < 8e6 || !window.createImageBitmap) return res(file);
      createImageBitmap(file).then(function (bmp) {
        var k = Math.min(1, 3000 / Math.max(bmp.width, bmp.height)), c = document.createElement('canvas');
        c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (b) { res(b ? new File([b], (file.name || 'shot').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.88);
      }).catch(function () { res(file); });
    });
  }
  function send(endpoint, data, file, progress) {
    if (!isCloud(endpoint)) return fetch(endpoint, { method: 'POST', body: data }).then(function (r) { if (!r.ok) throw new Error(r.status); return {}; });
    var video = /^video\//.test(file.type);
    if (video && file.size > 100e6) return Promise.reject(userErr('That video is over 100MB. Trim it a bit, or email it to ' + cfg().support + '.'));
    return shrink(file).then(function (f) {
      if (!video && f.size > 10e6) throw userErr('That photo is over 10MB. Try a screenshot of it, or email it to ' + cfg().support + '.');
      var keys = ['handle', 'location', 'story', 'product', 'page', 'club', 'club_handle', 'club_partner', 'club_instagram', 'consent', 'submitted_at'];
      var ctx = keys.map(function (k) { return k + '=' + ctxVal(data.get(k)); }).join('|');
      var tags = ['h32-shot', 'h32-pending', 'ig-' + String(data.get('handle') || '').toLowerCase()];
      if (data.get('club_partner') === 'yes') tags.push('h32-club-partner');
      var fd = new FormData();
      fd.append('file', f); fd.append('upload_preset', 'h32_shots'); fd.append('context', ctx); fd.append('tags', tags.join(','));
      return new Promise(function (res, rej) {
        var x = new XMLHttpRequest();
        x.open('POST', endpoint.replace(/\/(image|video|raw)\/upload/, '/auto/upload'));
        x.upload.onprogress = function (ev) { if (ev.lengthComputable && progress) progress(Math.round(ev.loaded / ev.total * 100)); };
        x.onload = function () { var j = {}; try { j = JSON.parse(x.responseText); } catch (e) {} if (x.status >= 200 && x.status < 300 && j.secure_url) res(j); else rej(userErr(j.error && /format/i.test(j.error.message || '') ? 'That file type isn’t supported. Send a JPG, PNG, MP4 or MOV.' : 'That didn’t send. Check your connection and try again.')); };
        x.onerror = function () { rej(new Error('network')); };
        x.send(fd);
      });
    });
  }
  function notify() { /* new shots are picked up from the h32-pending tag by HQ; no email needed */ }

  /* Klaviyo client API (public key, safe in the browser). Shopify's /contact and customer forms
     need a CAPTCHA token when posted from script, so email sign-ups go to Klaviyo instead. */
  var KL = 'Y4seLt', KREV = '2024-10-15', KLIST = 'YqibuE'; /* KLIST = Klaviyo list 'H32 Season Board' */
  function kpost(path, attrs) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KL, {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: KREV }, body: JSON.stringify({ data: attrs })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r; });
  }
  function kevent(name, email, props, profileProps) {
    return kpost('events', { type: 'event', attributes: {
      properties: props || {}, metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps || {} } } } } });
  }
  function ksubscribe(email, source) {
    return kpost('subscriptions', { type: 'subscription', attributes: { custom_source: source,
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: KLIST } } } });
  }

  /* ---------- upload ---------- */
  function initUpload(box) {
    if (!once(box, 'upload')) return;
    var form = $('[data-form]', box), done = $('[data-done]', box), err = $('[data-err]', box);
    var drop = $('[data-drop]', box), fileInput = $('input[type=file]', drop), preview = $('[data-preview]', box);
    var submit = $('[data-submit]', box), label = submit.textContent;
    var endpoint = box.getAttribute('data-endpoint');
    var clubSelect = $('[data-club-select]', box), clubOther = $('[data-club-other]', box);
    var emptyPreview = preview.innerHTML;
    clubSelect.addEventListener('change', function () { clubOther.hidden = clubSelect.value !== '__other'; if (!clubOther.hidden) clubOther.focus(); });
    fileInput.addEventListener('change', function () {
      var file = fileInput.files[0]; if (!file) return;
      var url = URL.createObjectURL(file);
      preview.innerHTML = (/^video\//.test(file.type) ? '<video src="' + url + '" muted playsinline></video>' : '<img src="' + url + '" alt="Your photo">') + '<span class="mono muted" style="font-size:11px">Tap to change</span>';
    });
    ['dragenter', 'dragover'].forEach(function (n) { drop.addEventListener(n, function (ev) { ev.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (n) { drop.addEventListener(n, function () { drop.classList.remove('is-over'); }); });
    function fail(msg) { err.textContent = msg; err.hidden = false; }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      var file = fileInput.files[0], handle = (form.handle.value || '').trim().replace(/^@+/, '');
      if (!file) return fail('Add a photo or video first.');
      if (!/^[A-Za-z0-9._]{1,30}$/.test(handle)) return fail('Add your Instagram handle, e.g. @yourname.');
      if (!form.consent.checked) return fail('Tick the box so we can repost it and add your points.');
      if (!endpoint) return fail('Uploads are not switched on yet. Please email ' + cfg().support + ' with your photo.');
      var data = new FormData(form), opt = clubSelect.options[clubSelect.selectedIndex];
      data.set('handle', handle);
      data.set('location', (form.location.value || '').trim());
      data.set('club', clubSelect.value === '__other' ? (clubOther.value || '').trim() : (clubSelect.value ? opt.text : ''));
      data.set('club_handle', clubSelect.value && clubSelect.value !== '__other' ? clubSelect.value : '');
      data.set('club_partner', opt && opt.getAttribute('data-p') === '1' ? 'yes' : 'no');
      data.set('club_instagram', (opt && opt.getAttribute('data-ig')) || '');
      data.delete('club_pick'); data.delete('club_other');
      data.set('submitted_at', new Date().toISOString());
      submit.disabled = true; submit.textContent = 'Sending…';
      send(endpoint, data, file, function (pct) { submit.textContent = pct < 100 ? 'Sending… ' + pct + '%' : 'Almost done…'; })
        .then(function (info) { notify(data, info); })
        .then(function () { var hs = $('[data-h32-signup] [name=handle]', done); if (hs) hs.value = handle; form.hidden = true; done.hidden = false; done.scrollIntoView({ behavior: 'smooth', block: 'center' }); })
        .catch(function (e) { fail(e && e.userMsg ? e.userMsg : 'That didn’t send. Check your connection and try again.'); })
        .then(function () { submit.disabled = false; submit.textContent = label; });
    });
    var again = $('[data-again]', box);
    if (again) again.addEventListener('click', function () { form.reset(); fileInput.value = ''; preview.innerHTML = emptyPreview; clubOther.hidden = true; done.hidden = true; form.hidden = false; });
    if (clubs.length) fillSelects(H.getLoc());
  }

  /* ---------- photo row arrows ---------- */
  function initPhotos(sec) {
    if (!once(sec, 'photos')) return;
    var row = $('.photos', sec);
    $$('[data-pdir]', sec).forEach(function (b) {
      b.addEventListener('click', function () { row.scrollBy({ left: Number(b.getAttribute('data-pdir')) * row.clientWidth * 0.84, behavior: 'smooth' }); });
    });
  }

  /* ---------- clubs (same feed as the homepage) ---------- */
  var H = null, clubs = [], byH = {}, loading = false;
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var WD = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 };
  function nextDate(c) {
    if (c.fd) { var d = new Date(c.fd); if (!isNaN(d) && d >= today) return { date: d, time: c.fd.length > 10 ? d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : (c.tm || '') }; }
    if (c.k === 'Event' && c.e) { var e = new Date(c.e + 'T12:00:00'); if (e >= today) return { date: e, time: c.tm || '' }; }
    var wd = WD[(c.d || '').toUpperCase()];
    if (wd != null) { var n = (wd - new Date().getDay() + 7) % 7, x = new Date(today); x.setDate(x.getDate() + n); return { date: x, time: c.tm || '' }; }
    return null;
  }
  function fmtDate(d) {
    var n = Math.round((d - today) / 864e5);
    if (n === 0) return 'Today'; if (n === 1) return 'Tomorrow';
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function rank(list, loc) {
    list = H.withDistance(list, loc);
    if (!loc) {
      var mk = { GB: 'UK', US: 'US', DE: 'DE' }[(window.Shopify && Shopify.country) || 'GB'] || 'UK';
      var local = list.filter(function (c) { return c.c === mk; });
      if (local.length) list = local;
    }
    list.forEach(function (c) { c._next = nextDate(c); var days = c._next ? Math.round((c._next.date - today) / 864e5) : 30; c._score = days + (c.dist != null ? c.dist / 10 : 0); });
    return list.sort(function (a, b) { return a._score - b._score; });
  }
  function partners() { return clubs.filter(function (c) { return c.p && !c.free; }); }

  function fillSelects(loc) {
    var bonus = cfg().bonus;
    var ps = rank(partners(), loc);
    var evs = rank(clubs.filter(function (c) { return c.k === 'Event' && !c.p; }), loc).slice(0, 8);
    var html = '<option value="">None, or pick your club</option>';
    if (ps.length) html += '<optgroup label="Partner clubs · +' + bonus + ' when they accept the collab">' + ps.map(function (c) { return '<option value="' + esc(c.h) + '" data-p="1" data-ig="' + esc(c.ig || '') + '">' + esc(c.n) + (c.t ? ' · ' + esc(c.t) : '') + '</option>'; }).join('') + '</optgroup>';
    if (evs.length) html += '<optgroup label="Upcoming events">' + evs.map(function (c) { var nx = c._next; return '<option value="' + esc(c.h) + '" data-ig="' + esc(c.ig || '') + '">' + esc(c.n) + (nx ? ' · ' + esc(fmtDate(nx.date)) : '') + '</option>'; }).join('') + '</optgroup>';
    html += '<option value="__other">Another club or event (type it in)</option>';
    $$('[data-club-select]').forEach(function (sel) {
      var keep = sel.value; sel.innerHTML = html;
      if (keep && sel.querySelector('option[value="' + keep.replace(/"/g, '') + '"]')) sel.value = keep;
    });
  }

  var crews = [];
  function initCrew(sec) {
    if (!once(sec, 'crew')) return;
    var st = {
      sec: sec, track: $('[data-crew-track]', sec), bar: $('[data-crew-bar]', sec), dots: $('[data-crew-dots]', sec),
      count: $('[data-crew-count]', sec), arrows: $$('.arrows button', sec), near: $('[data-near-label]', sec), shown: [], idx: 0
    };
    st.arrows.forEach(function (b) { b.addEventListener('click', function () { go(st, Math.max(0, Math.min(st.shown.length - 1, st.idx + Number(b.getAttribute('data-dir'))))); }); });
    st.dots.addEventListener('click', function (e) { var d = e.target.closest('[data-go]'); if (d) go(st, Number(d.getAttribute('data-go'))); });
    var tmr; st.track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(function () { paintNav(st); }, 120); }, { passive: true });
    crews.push(st);
    if (clubs.length) renderCrew(st, H.getLoc());
  }
  function slide(c, i, n) {
    var nx = c._next;
    var when = nx ? fmtDate(nx.date) + (nx.time ? ' · ' + nx.time : '') : (c.s || 'Ask the club');
    var where = [c.l, c.t].filter(Boolean).filter(function (v, k, a) { return a.indexOf(v) === k; }).join(', ') || c.t || '';
    var dist = c.dist != null ? H.fmtDist(c.dist, c.c) + ' away' : '';
    return '<article class="slide" aria-label="' + (i + 1) + ' of ' + n + ': ' + esc(c.n) + '">' +
      '<div style="display:flex;flex-direction:column;gap:6px"><h3>' + esc(c.n) + '</h3><span class="x">× Hiemal32</span></div>' +
      '<dl><dt>When</dt><dd>' + esc(when) + '</dd><dt>Where</dt><dd>' + esc(where) + (dist ? ' · ' + esc(dist) : '') + '</dd></dl>' +
      (c.wm ? '<blockquote><p>“' + esc(c.wm) + '”</p><cite>' + esc(c.wf ? c.wf + ', ' + c.n : c.n) + '</cite></blockquote>' : '') +
      (c.pk ? '<p class="perk">' + esc(c.pk) + '</p>' : '') +
      '<div class="btns"><button type="button" class="btn" data-h32-join="' + esc(c.h) + '">Join the club</button>' + (c.la != null ? '<a class="btn ghost" href="' + esc(H.directions(c)) + '" target="_blank" rel="noopener">Directions</a>' : '') + '</div>' +
      '</article>';
  }
  function paintNav(st) {
    var first = st.track.firstElementChild, w = first ? first.getBoundingClientRect().width + 16 : 1;
    st.idx = Math.max(0, Math.min(st.shown.length - 1, Math.round(st.track.scrollLeft / w)));
    st.count.textContent = (st.idx + 1) + ' / ' + st.shown.length;
    $$('button', st.dots).forEach(function (d, k) { d.classList.toggle('on', k === st.idx); });
    if (st.arrows.length) { st.arrows[0].disabled = st.idx === 0; st.arrows[1].disabled = st.idx >= st.shown.length - 1; }
  }
  function go(st, i) { var el = st.track.children[i]; if (!el) return; st.track.scrollTo({ left: el.offsetLeft - st.track.firstElementChild.offsetLeft, behavior: 'smooth' }); }
  function renderCrew(st, loc) {
    st.near.textContent = (loc && loc.label ? 'Near ' + (loc.label === 'you' ? 'you' : loc.label) : 'Near you') + ' · Change';
    st.shown = rank(partners(), loc).slice(0, 8);
    if (!st.shown.length) { st.bar.hidden = true; st.track.innerHTML = '<p class="lede">Partner clubs near you are coming soon. See the full list for everything on the map.</p>'; return; }
    st.bar.hidden = false;
    st.track.innerHTML = st.shown.map(function (c, i) { return slide(c, i, st.shown.length); }).join('');
    st.dots.innerHTML = st.shown.map(function (c, k) { return '<button type="button" aria-label="Show club ' + (k + 1) + '" data-go="' + k + '"></button>'; }).join('');
    st.track.scrollLeft = 0; paintNav(st);
    if (st.arrows[0]) st.arrows[0].parentNode.hidden = st.shown.length < 2;
  }
  function renderAll(loc) { crews.forEach(function (st) { if (document.contains(st.sec)) renderCrew(st, loc); }); fillSelects(loc); if (listState.m && listState.m.classList.contains('is-open')) renderList(); }

  /* full list + map */
  var listState = { m: null, act: '', partners: false, map: null, cluster: null, markers: {}, me: null };
  function rowHtml(c) {
    var bonus = cfg().bonus, w = H.when(c), where = c.t || c.l || '';
    var dist = c.dist != null ? ' · ' + H.fmtDist(c.dist, c.c) : '';
    var acts = (c.a || []).map(function (a) { return a === 'Swim' ? 'Wild swim' : a; }).join(' · ');
    return '<button type="button" class="crow" data-h="' + esc(c.h) + '"><span style="min-width:0"><b>' + esc(c.n) + '</b><small>' + esc(c.k) + (acts ? ' · ' + esc(acts) : '') + ' · ' + esc(where) + dist + ' · ' + esc(w.value) + '</small></span>' +
      (c.p ? '<span class="badge p">Partner · +' + bonus + '</span>' : '<span class="badge">Listed</span>') + '</button>';
  }
  function filtered(loc) {
    var list = clubs.filter(function (c) {
      if (listState.partners && !c.p) return false;
      if (listState.act) { var have = (c.a || []).map(function (x) { return x.toLowerCase(); }); if (have.indexOf(listState.act) < 0) return false; }
      return true;
    });
    list = H.withDistance(list, loc);
    return list.sort(function (x, y) {
      if (loc) { if (x.dist == null) return 1; if (y.dist == null) return -1; return x.dist - y.dist; }
      if (x.p !== y.p) return x.p ? -1 : 1;
      return x.n.localeCompare(y.n);
    });
  }
  function renderList() {
    var m = listState.m; if (!m || !H) return;
    var loc = H.getLoc(), clist = $('[data-clist]', m), bonus = cfg().bonus;
    $('[data-loc-label]', m).textContent = loc && loc.label ? 'Showing nearest to ' + (loc.label === 'you' ? 'you' : loc.label) : 'Set your location to sort by distance';
    var list = filtered(loc), top = list.slice(0, 60);
    clist.innerHTML = top.length ? top.map(rowHtml).join('') : '<p class="lede">' + (clubs.length ? 'Nothing matches yet. Try another activity.' : 'Loading clubs…') + '</p>';
    $('[data-cnote]', m).textContent = clubs.length ? 'Showing ' + top.length + ' of ' + list.length + '. Partners welcome first-timers, and shots with them earn +' + bonus + ' when the club accepts the collab.' : '';
    drawMap(list, loc);
  }
  function drawMap(list, loc) {
    var s = listState; if (!window.L || !s.map) return;
    var bonus = cfg().bonus;
    s.cluster.clearLayers(); s.markers = {};
    list.forEach(function (c) {
      if (c.la == null) return;
      var mk = L.marker([c.la, c.lo], { icon: L.divIcon({ className: '', html: '<div class="pin' + (c.p ? ' p' : '') + '"></div>', iconSize: c.p ? [20, 20] : [14, 14], iconAnchor: c.p ? [10, 10] : [7, 7] }) });
      mk.bindPopup('<b>' + esc(c.n) + '</b><br>' + esc(c.t || '') + (c.p ? '<br>Partner · +' + bonus : ''));
      mk.on('click', function () { selRow(c.h, true); });
      s.cluster.addLayer(mk); s.markers[c.h] = mk;
    });
    if (s.me) { s.map.removeLayer(s.me); s.me = null; }
    if (loc) { s.me = L.marker([loc.lat, loc.lng], { icon: H.meIcon(loc), interactive: false }).addTo(s.map); s.map.setView([loc.lat, loc.lng], 9); }
    else if (s.cluster.getLayers().length) s.map.fitBounds(s.cluster.getBounds(), { padding: [20, 20], maxZoom: 9 });
  }
  function selRow(h, scroll) {
    var clist = $('[data-clist]', listState.m);
    $$('.crow', clist).forEach(function (r) { r.classList.toggle('sel', r.getAttribute('data-h') === h); });
    var r = clist.querySelector('.crow[data-h="' + h.replace(/"/g, '') + '"]');
    if (r && scroll) r.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function setLoc(loc) { H.saveLoc(loc); renderAll(loc); renderList(); }
  function initClubsModal(m) {
    listState = { m: m, act: '', partners: false, map: null, cluster: null, markers: {}, me: null };
    var label = $('[data-loc-label]', m);
    $('[data-clist]', m).addEventListener('click', function (e) {
      var r = e.target.closest('.crow'); if (!r) return;
      var h = r.getAttribute('data-h'), c = byH[h], s = listState; selRow(h);
      if (s.map && s.markers[h]) s.cluster.zoomToShowLayer(s.markers[h], function () { s.map.setView([c.la, c.lo], Math.max(s.map.getZoom(), 11)); s.markers[h].openPopup(); });
    });
    $('[data-chips]', m).addEventListener('click', function (e) {
      var b = e.target.closest('.chip'); if (!b) return;
      if (b.hasAttribute('data-partners')) { listState.partners = !listState.partners; b.classList.toggle('on', listState.partners); }
      else { listState.act = b.getAttribute('data-act'); $$('[data-act]', m).forEach(function (x) { x.classList.toggle('on', x === b); }); }
      renderList();
    });
    $('[data-loc-form]', m).addEventListener('submit', function (e) {
      e.preventDefault(); if (!H) return;
      label.textContent = 'Finding…';
      H.geocode($('[data-loc-input]', m).value).then(setLoc).catch(function () { label.textContent = 'Couldn’t find that. Try a town or postcode.'; });
    });
    $('[data-locate]', m).addEventListener('click', function () {
      if (!H) return;
      label.textContent = 'Finding you…';
      H.locateMe().then(setLoc).catch(function () { label.textContent = 'Location is blocked. Type a town or postcode instead.'; });
    });
  }
  openHooks.clubs = function () {
    var s = listState; if (!H || !s.m) return;
    if (!s.map) {
      H.loadLeaflet().then(function () {
        if (s.map) return;
        s.map = L.map($('[data-cmap]', s.m), { scrollWheelZoom: false, zoomControl: true }).setView([54, -2], 5);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap contributors' }).addTo(s.map);
        s.cluster = H.clusterGroup(); s.map.addLayer(s.cluster);
        renderList();
        setTimeout(function () { s.map.invalidateSize(); }, 50);
      });
    } else setTimeout(function () { s.map.invalidateSize(); }, 50);
    renderList();
  };

  /* join a club: intro request + optional reminders sign-up */
  function openJoin(h, opener) {
    var m = modals.join, c = byH[h]; if (!m || !c) return;
    $('[data-join-name]', m).textContent = c.n;
    $('[data-join-club]', m).value = h;
    $('[data-join-lede]', m).textContent = 'Leave your details and we’ll email you and ' + c.n + ' to set up your first session' + (c.pk ? ': ' + c.pk + '.' : '.');
    $('[data-join-form]', m).hidden = false; $('[data-join-done]', m).hidden = true; $('[data-join-err]', m).hidden = true;
    openModal('join', opener);
  }
  function post(fields) {
    var body = new URLSearchParams(); body.append('utf8', '✓');
    Object.keys(fields).forEach(function (k) { body.append(k, fields[k]); });
    return fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin' }).then(function (r) { if (/challenge/.test(r.url) || !r.ok) throw new Error('blocked'); return r; });
  }
  function initJoin(m) {
    var jform = $('[data-join-form]', m), jerr = $('[data-join-err]', m), jdone = $('[data-join-done]', m), btn = $('[data-join-submit]', m), label = btn.textContent;
    jform.addEventListener('submit', function (e) {
      e.preventDefault(); jerr.hidden = true;
      var k = cfg(), c = byH[jform.club.value] || {}, first = (jform.first.value || '').trim(), email = (jform.email.value || '').trim();
      if (!first) { jerr.textContent = 'Add your first name.'; jerr.hidden = false; return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { jerr.textContent = 'Add a valid email.'; jerr.hidden = false; return; }
      btn.disabled = true; btn.textContent = 'Sending…';
      var insta = (jform.insta.value || '').trim(), rem = jform.reminders.checked;
      var jobs = [post({ form_type: 'contact', 'contact[name]': first, 'contact[email]': email, 'contact[Club]': c.n || '', 'contact[Club handle]': c.h || '', 'contact[Instagram]': insta, 'contact[Reminders]': rem ? 'Yes' : 'No', 'contact[Product]': k.product, 'contact[body]': 'Club intro request from the ' + k.product + ' owner page.' })];
      if (rem) jobs.push(post({ form_type: 'customer', 'contact[email]': email, 'contact[first_name]': first, 'contact[tags]': 'h32-owner,season-board-reminders,club-intro,club-' + (c.h || '') }));
      Promise.all(jobs).then(function () { jform.hidden = true; jdone.hidden = false; })
        .catch(function () { jerr.innerHTML = 'That didn’t send. Email <a href="mailto:' + esc(k.support) + '?subject=' + encodeURIComponent('Club intro: ' + (c.n || '')) + '" target="_blank" rel="noopener">' + esc(k.support) + '</a> and we’ll sort it.'; jerr.hidden = false; })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  /* ---------- email sign-ups (after upload + reminders section) ---------- */
  function initSignup(form) {
    if (!once(form, 'signup')) return;
    var err = $('[data-signup-err]', form), btn = $('button[type=submit]', form), label = btn.textContent;
    var done = form.parentNode.querySelector('[data-signup-done]');
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      var k = cfg(), email = (form.email.value || '').trim();
      var handle = ((form.handle && form.handle.value) || '').trim().replace(/^@+/, '');
      var newsBox = form.querySelector('[name=news]'), updBox = form.querySelector('[name=updates]');
      var news = newsBox ? newsBox.checked : true, updates = updBox ? updBox.checked : false;
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Add a valid email.'; err.hidden = false; return; }
      if (!news && !updates) { err.textContent = 'Tick at least one box.'; err.hidden = false; return; }
      btn.disabled = true; btn.textContent = 'Saving…';
      var jobs = [], endpoint = form.getAttribute('data-endpoint');
      var pp = { h32_instagram: handle ? '@' + handle : '', h32_source_page: location.pathname, h32_product: k.product };
      if (updates) pp.h32_points_updates = true;
      if (news) pp.h32_season_reminders = true;
      jobs.push(kevent(updates ? 'H32 Season Board updates sign-up' : 'H32 Season Board reminders sign-up', email,
        { instagram: pp.h32_instagram, page: location.pathname, product: k.product, updates: updates, marketing: news }, pp));
      if (news) jobs.push(ksubscribe(email, 'H32 Season Board · ' + location.pathname));
      if (endpoint && !isCloud(endpoint)) {
        var d = new FormData();
        d.append('kind', 'email'); d.append('email', email); d.append('handle', handle);
        d.append('updates', updates ? 'yes' : 'no'); d.append('news', news ? 'yes' : 'no');
        d.append('product', k.product); d.append('page', location.pathname); d.append('submitted_at', new Date().toISOString());
        jobs.push(fetch(endpoint, { method: 'POST', body: d }).then(function (r) { if (!r.ok) throw new Error(r.status); }));
      }
      Promise.all(jobs).then(function () { form.hidden = true; if (done) done.hidden = false; })
        .catch(function () { err.innerHTML = 'That didn’t save. Email <a href="mailto:' + esc(k.support) + '" target="_blank" rel="noopener">' + esc(k.support) + '</a> and we’ll add you.'; err.hidden = false; })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  function loadClubs() {
    if (loading || !window.H32Clubs) return;
    loading = true; H = window.H32Clubs;
    H.load().then(function (list) {
      clubs = list; byH = {}; clubs.forEach(function (c) { byH[c.h] = c; });
      renderAll(H.getLoc());
    });
    window.addEventListener('h32:location', function (e) { if (clubs.length && e.detail) renderAll(e.detail); });
  }

  /* ---------- scan: run on load and whenever the theme editor re-renders a section ---------- */
  O.scan = function () {
    $$('[data-h32-modal]').forEach(registerModal);
    $$('[data-h32-upload]').forEach(initUpload);
    $$('[data-h32-crew]').forEach(initCrew);
    $$('[data-h32-photos]').forEach(initPhotos);
    $$('[data-h32-signup]').forEach(initSignup);
    crews = crews.filter(function (st) { return document.contains(st.sec); });
    paintDates(); tick();
    if (!H) { if (window.H32Clubs) loadClubs(); else window.addEventListener('load', loadClubs); }
  };
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId; if (!id) return;
    $$('.h32ol-modal[data-h32-section="' + id + '"]').forEach(function (m) {
      var name = m.getAttribute('data-h32-modal'); if (modals[name] === m) delete modals[name];
      if (m.classList.contains('is-open')) closeModal(m);
      m.parentNode.removeChild(m);
    });
  });
  document.addEventListener('shopify:section:load', function () { O.scan(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', O.scan); else O.scan();
})();
